import { apiClient } from './client';
import { env } from '../../config/env';

export interface FeedbackFormData {
  feedback_type: 'bug' | 'feature_request';
  title: string;
  description: string;
  is_blocking: boolean;
}

export const feedbackApi = {
  submit: async (data: FeedbackFormData, files: File[]): Promise<{ message: string }> => {
    const formData = new FormData();
    formData.append('feedback_type', data.feedback_type);
    formData.append('title', data.title);
    formData.append('description', data.description);
    formData.append('is_blocking', String(data.is_blocking));
    formData.append('page_url', window.location.href);
    formData.append('browser_os', navigator.userAgent);
    formData.append('app_version', env.appVersion);
    formData.append('build_number', env.buildNumber || 'dev');
    formData.append('environment', env.environment);

    files.forEach(file => {
      formData.append('attachments', file);
    });

    return apiClient.postFormData<{ message: string }>('/api/feedback', formData);
  },
};
